module.exports = __webpack_public_path__ + "media/categories/2024-22c77ac2.svg";